export default __webpack_public_path__ + "static/media/share.135165a6.png";